﻿import { onlyDigits } from "@js/core/utils/text";
import { detectCardType, isValidLuhn, isValidExpireDate } from "@js/core/forms/card";
import { t, currentLang } from "@js/core/utils/i18n";

let checkoutValidatorsRegistered = false;

export function registerCheckoutValidators() {
    if (!window.Parsley || checkoutValidatorsRegistered) return;

    window.Parsley.addValidator("expirydate", {
        validateString(value) {
            return isValidExpireDate(value);
        },
        messages: {
            [currentLang()]: t("Validation.ExpireDate")
        }
    });

    window.Parsley.addValidator("cvv", {
        validateString(value) {
            const digits = onlyDigits(value);
            return digits.length === 3 || digits.length === 4;
        },
        messages: {
            [currentLang()]: t("Validation.Cvv")
        }
    });

    window.Parsley.addValidator("cardholder", {
        validateString(value) {
            if (!value) return false;

            const clean = value.trim().replace(/\s+/g, " ");
            const validChars = /^[a-zA-ZçÇğĞıİöÖşŞüÜ\s]+$/.test(clean);
            if (!validChars) return false;

            const parts = clean.split(" ");
            if (parts.length < 2) return false;

            for (let i = 0; i < parts.length; i++) {
                if (parts[i].length < 2) return false;
            }

            return true;
        },
        messages: {
            [currentLang()]: t("Validation.CardHolder")
        }
    });

    window.Parsley.addValidator("cardnumber", {
        validateString(value) {
            const digits = onlyDigits(value);
            const cardType = detectCardType(digits);

            if (cardType === "amex") {
                if (digits.length !== 15) return false;
            } else {
                if (digits.length !== 16) return false;
            }

            return isValidLuhn(digits);
        },
        messages: {
            [currentLang()]: t("Validation.CardNumber")
        }
    });

    window.Parsley.addValidator("amountpositive", {
        validateString(value) {
            if (!value) return false;

            const normalized = value.replace(/\./g, "").replace(",", ".");
            const number = parseFloat(normalized);

            return !Number.isNaN(number) && number > 0;
        },
        messages: {
            [currentLang()]: t("Validation.Amount")
        }
    });

    checkoutValidatorsRegistered = true;
}

export function initCheckoutParsley(formSelector = "#paymentCheckoutForm") {
    if (!window.jQuery || !window.Parsley) return null;

    const $ = window.jQuery;
    const $form = $(formSelector);

    if (!$form.length) return null;

    return $form.parsley({
        errorClass: "is-invalid",
        successClass: "is-valid",
        classHandler(field) {
            if (field.$element.attr("id") === "ApproveTerms") {
                return field.$element.closest(".checkout-approve-box");
            }

            return field.$element.closest(".field");
        },
        errorsContainer(field) {
            if (field.$element.attr("id") === "ApproveTerms") {
                return field.$element.closest(".checkout-approve-box").find(".approve-error");
            }

            return field.$element.closest(".field");
        }
    });
}